/* eslint-disable */
import Breakpoint from '../modules/breakpoint';

export default el => {
    const btns = el.querySelectorAll("button");

    function Tabs() {
        const onclick = (selected) => {
            btns.forEach(btn => {
                btn.classList[btn === selected ? "add" : "remove"]("active");
            });
        };

        this.disable = () => {
            btns.forEach(btn => btn.onclick = () => { });
        }
        this.enable = () => {
            btns.forEach(btn => btn.onclick = () => onclick(btn));
        }
    }

    function Accordion() {

        function resize(){
            btns.forEach(btn => {
                btns.forEach(btn => {
                    if (btn.classList.contains('open')) {
                        btn.nextElementSibling.style.setProperty('--height', `auto`)
                    }
                })
            })
        }

        btns.forEach(btn => {
            let isOpen = false;
        
            const onclick = (btn) => {
                const el = btn.nextElementSibling;
                const wrapper = el.querySelector(".wrapper");
                if (isOpen === false) {
                    isOpen = true;
                    btn.classList.add('open');
                    el.style.setProperty('--height', `${wrapper.clientHeight}px`);
                   // el.addEventListener("transitionend", () => el.style.setProperty('--height', `auto`), { once: true });
                } else {
                    isOpen = false;
                    btn.classList.remove('open');
                    el.style.setProperty('--height', `${wrapper.clientHeight}px`);
                    setTimeout(() => el.style.setProperty('--height', `0px`), 1)
                }
            };

            this.disable = () => {
                btns.forEach(btn => btn.onclick = () => { });
            }
            this.enable = () => {
                btns.forEach(btn => btn.onclick = () => onclick(btn));
            }
        });

        window.addEventListener("resize", resize);
    }

    const breakpoint = new Breakpoint(1280);
    const tabs = new Tabs();
    const accordion = new Accordion();

    breakpoint.under = () => {
        console.log('under');
       //  tabs.disable();
        accordion.enable();
    }
    breakpoint.above = () => {
        console.log('above');
        tabs.enable();
        //  accordion.disable();
    }
};

